import React, { useState, useEffect } from "react";
import "../style/style.css";

const Carousel = () => {
  const slides = [
    { id: 1, img: "https://picsum.photos/800/400?random=1" },
    { id: 2, img: "https://picsum.photos/800/400?random=2" },
    { id: 3, img: "https://picsum.photos/800/400?random=3" },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-slide effect
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === slides.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000); // 3 seconds
    return () => clearInterval(timer);
  }, [slides.length]);

  // Handle circle click
  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="carousel">
      <div
        className="carousel-inner"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {slides.map((slide) => (
          <div className="carousel-item" key={slide.id}>
            <img src={slide.img} alt={`Slide ${slide.id}`} />
          </div>
        ))}
      </div>

      {/* Circle navigation */}
      <div className="carousel-dots">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`dot ${currentIndex === index ? "active" : ""}`}
            onClick={() => goToSlide(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default Carousel;
